import axios from 'axios';
import axiosRetry from 'axios-retry';
import toastr from 'toastr';
import * as actions from './actionsTypes';
import errorManage from '../../errorManage';
import messages from '../../messages';

const client = axios.create({ baseURL: process.env.REACT_APP_URL });
axiosRetry(client, { retries: 5, retryDelay: axiosRetry.exponentialDelay });

export const getPREGUNTA = data => async (dispatch, getState) => {
  try {
    dispatch({     
      type: actions.LOADING_PREGUNTA,
      payload: true
    });
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.get(`/api/app/Clima_Tipo_Pregunta/`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      },
      params: data
    });
    dispatch({
      type: actions.GET_PREGUNTA,
      payload: {
        TipoPregunta: resp.data.data,
        TipoPreguntaLength: resp.data.count
      }
    });
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_PREGUNTA,
      payload: false
    });
  }
}

export const savePREGUNTA = data => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADER_PREGUNTA,
      payload: true
    });

    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.post('/api/app/Clima_Tipo_Pregunta/', data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`
      }});
    const { TipoPregunta, TipoPreguntaLength } = getState().TipoPregunta;
    const aTipoPregunta = [...TipoPregunta, resp.data];
    dispatch({
      type: actions.GET_PREGUNTA,
      payload: {
        TipoPregunta: aTipoPregunta,
        TipoPreguntaLength: TipoPreguntaLength + 1
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.SAVE_LOADER_PREGUNTA,
      payload: false
    });
  }
}

export const editPREGUNTA = (data, id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_PREGUNTA,
      payload: true
    });
  
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    const resp = await client.put(`/api/app/Clima_Tipo_Pregunta/${id}/`, data, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});
    const { TipoPregunta, TipoPreguntaLength } = getState().TipoPregunta;
    TipoPregunta[index] = resp.data;
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_PREGUNTA,
      payload: {
        TipoPregunta: TipoPregunta,
        TipoPreguntaLength: TipoPreguntaLength
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_PREGUNTA,
      payload: false
    });
  }
}

export const deletePREGUNTA = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_PREGUNTA,
      payload: true
    });
    
    const { token } = getState().auth || localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : {token: ''};
    await client.delete(`/api/app/Clima_Tipo_Pregunta/${id}/`, {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Token ${token}`
    }});
    const { TipoPregunta, TipoPreguntaLength } = getState().TipoPregunta;
    TipoPregunta.splice(index, 1);
    //const aJobPositions = [...jobPositions, resp.data];
    dispatch({
      type: actions.GET_PREGUNTA,
      payload: {
        TipoPregunta: TipoPregunta,
        TipoPreguntaLength: TipoPreguntaLength -1
      }
    });
    toastr.success(messages.successMessage);
  } catch (ex) {
    if(ex.response){
      if(ex.response.status === 400){
        if(Array.isArray(ex.response.data)){
          ex.response.data.forEach(item => {
            toastr.error(item);
          });
        }else{
          toastr.error(ex.response.data);
        }
      }else{
        errorManage(ex);
      }
    }else{
      errorManage(ex);
    }
  }finally{
    dispatch({
      type: actions.LOADING_PREGUNTA,
      payload: false
    });
  }
}

